import React from 'react';
import { usePurchasePopup } from '../hooks/usePurchasePopup';
import { CheckCircle2 } from 'lucide-react';
export function PurchasePopup() {
  const {
    isVisible,
    purchaser
  } = usePurchasePopup();
  if (!isVisible) return null;
  return <div className="fixed bottom-4 left-4 z-50 animate-in slide-in-from-bottom-5 fade-in duration-500" data-id="element-273">
      <div className="bg-white rounded-lg shadow-xl p-4 flex items-center gap-3 border-l-4 border-[#d4a853] max-w-sm" data-id="element-274">
        <div className="bg-green-100 p-2 rounded-full" data-id="element-275">
          <CheckCircle2 className="w-6 h-6 text-green-600" data-id="element-276" />
        </div>
        <div data-id="element-277">
          <p className="text-sm font-medium text-gray-900" data-id="element-278">
            <span className="font-bold" data-id="element-279">{purchaser}</span>
          </p>
          <p className="text-xs text-gray-600" data-id="element-280">
            acaba de comprar Política y Ciudadanía 360
          </p>
        </div>
      </div>
    </div>;
}